// extracted by mini-css-extract-plugin
export default {"addCommute":"styles_addCommute__qGpmv","wrapper":"styles_wrapper__-V9MX","icon":"styles_icon__BRbt9","text":"styles_text__ZoLUp"};